<template>
  <div class="col pa-0">
    <v-row v-if="viewMode && attachmentList && attachmentList.length >0">
      <v-col class="pa-0">
        <label> {{ local.common.attachments }}</label>
        <div class="d-block">
          <naj-button
            v-for="(attachment , index) in attachmentList"
            :key="index"
            class="attachment-btn pe-2"
            square
            icon="mdi-paperclip"
            :disabled="attachment.disabled"
            @click="downloadAttachment(attachment)"
          >
            {{ attachment.fileName }}
          </naj-button>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="!viewMode && attachmentList && attachmentList.length >0">
      <v-col class="pa-0">
        <label> {{ local.common.attachments }}</label>
        <div class="d-block">
          <span
            v-for="(attachment , index) in attachmentList"
            :key="index"
            class="attachment-btn pe-2"
          >
            <v-icon class="icon">mdi-paperclip</v-icon>
            {{ attachment.fileName }}

            <button>
              <v-icon
                class="icon"
                @click="deleteAttachemnt"
              >mdi-close</v-icon>
            </button>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="!viewMode && (!attachmentList || attachmentList.length ==0)"
      class="add-attachment-container"
    >
      <v-col class="pa-0">
        <input
          ref="attachmentFileInput"
          type="file"
          style="display:none"
          @change="inputFileChangeHandler"
        >
        <label>{{ local.common.addAttachment }}</label>
        <button
          id="attachment-file-input"
          type="button"
          :class="['scan-button']"
          @click="openFilePicker"
        >
          <span :class="[{ 'required-attachment': false }, { 'error--text': errorMessage }]">
            <v-icon class="icon">mdi-cloud-upload-outline</v-icon>
            {{ local.common.upload }}
          </span>
          <naj-error-text
            v-if="errorMessage"
            :text="errorMessage"
            size="small"
            no-margin
            class="error-text"
          ></naj-error-text>
        </button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');
export default {
  name: 'NajAttachment',
  props: {
    attachmentList: {
      type: Array,
      default: () => ([]),
      required: false,
    },
    addAttachmentText: {
      type: String,
      required: false,
      default: '',
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      reader: new FileReader(),
      errorMessage: null,
      selectedAttachment: {},
    };
  },
  created() {
    this.reader.onload = (e) => {
      this.updateFileBase64(e.target.result);
    };
  },
  methods: {
    ...mapComplaintsActions([
      'getAttachmentDetails',
    ]),
    updateFileBase64(file) {
      if (this.selectedAttachment) {
        this.selectedAttachment.attachmentBase64 = file.split(',')[1];
        this.attachmentList.push(this.selectedAttachment);
      }
      this.$emit('update:attachmentList', this.attachmentList);
    },
    inputFileChangeHandler(e) {
      this.errorMessage = null;
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 5000000) {
        this.errorMessage = 'max size exceeded';
        return;
      }
      this.prepareFileObject(file);
    },
    prepareFileObject(file) {

      let extension = '.' + file.name.split('.')
        .pop();

      this.selectedAttachment = {
        fileObject: file,
        fileSize: file.size,
        contentType: file.type,
        fileName: file.name.split('.')[0],
        fileExtension: extension,
      };

      this.reader.abort(); // cancel the read operation if found
      this.reader.readAsDataURL(file);
      this.resetFileInput(); // reset file input value
    },
    resetFileInput() {
      if (this.$refs.attachmentFileInput) this.$refs.attachmentFileInput.value = '';
    },
    deleteAttachemnt() {
      this.attachmentList.pop();
    },
    openFilePicker() {
      if (!this.hasAttachment)
        this.$refs.attachmentFileInput.click();
    },
    downloadAttachment(attachment) {
      attachment.disabled = true;
      var payload = {
        complaintNo: attachment.complaintNo,
        id: attachment.spid ? attachment.spid : attachment.fileIDEncrypted,
      };
      this.getAttachmentDetails(payload)
        .then(({ data }) => {
          var a = document.createElement('a'); //create <a>

          a.href = 'data:' + data.contentType + ';base64,' + data.base64String; //image Base64 Goes here
          a.download = attachment.fileName; //file name Here
          a.click(); //downloaded file
        })
        .finally(() => {
          attachment.disabled = false;
        });
    },
  },
};
</script>
<style lang="scss">
.image-form-container {
  .v-input {
    margin-top: 0 !important;
  }
  .v-label {
    display: none !important;
  }
  .attachment-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content-wrapper {
    display: flex;
    max-width: 90%;
    align-items: center;
  }

  .attachment-item .file-info {
    font-size: 16px;
    padding-inline: 4px;
  }

  .attachment-name {
    display: none;
  }

  .action-btn {
    border: none !important;
  }
  .scan-button {
    margin: 0 auto;
    margin-bottom: 8px;
    width: 100%;
    height: 85%;
    display: block;
    padding: 5px 20px;
    position: relative;
    background: none;
    border: 2px dashed #d8d9e2;
    border-radius: 8px;
    font-size: 20px;
    font-weight: 500;
    color: #484952;
    text-align: center;
    .attachment-image {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      will-change: opacity;
      transition: opacity 0.4s;
    }
    .button-text {
      display: block;
      opacity: 1;
      will-change: opacity;
      transition: opacity 0.4s;
    }
    .delete-attachment {
      color: #e14747;
      margin-top: 10px;
      cursor: pointer;
      line-height: 1;
      padding: 6px 15px 3px;
      border-radius: 100px;
      font-size: 16px;
      border: 1px solid #e14747;
      &:hover {
        background-color: #e14747;
        color: #fff;
      }
    }
    &.has-image {
      &:hover {
        .attachment-image {
          opacity: 0.2;
        }
      }
    }
    .icon {
      display: block;
      font-size: 32px;
      color: #000;
      &:after {
        width: 0;
      }
    }
  }
  ::v-deep .naj-box .naj-box-content {
    padding-bottom: 30px;
  }
  .form-input ::v-deep .v-input {
    margin-top: 0 !important;
    margin-bottom: 40px;
  }
  .required-attachment:after {
    content: "*";
    color: #ff3547;
    display: inline-block;
    margin-right: 5px;
  }
  .error-text {
    padding: 0 12px;
  }
}

.attachment-btn {
  &.v-button-wrapper .naj-button.primary {
    background-color: #203f39 !important;
    border-color: #203f39 !important;
  }
}

.add-attachment-container {
  margin-top: 12px !important;
  border-right: 2px solid #b69a70;
  border-left: 2px solid #b69a70;
  padding: 1.5rem 1.5rem;
  margin-bottom: 20px !important;
  label {
    font-size: 18px;
    margin: 0 0 7px 0;
    display: block;
    color: #343a40;
    font-weight: 600;
  }
  .scan-button {
    border: 2px dashed #ced4da;
    background: #fff;
    border-radius: 6px;
    cursor: pointer;
    min-height: 150px;
    padding: 20px;
    box-shadow: none;
    display: block;
    width: 100%;
    color: #343a40;
    font-weight: 600;
    font-size: 1.5rem;
    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    i {
      margin: 10px 0;
      font-size: 36px;
      color: #98a6ad;
    }
  }
}

span.attachment-btn {
  background-color: #f4f4f4 !important;
  min-width: 104px;
  border-radius: 4px;
  color: #203f39;
  font-weight: 400;
  font-size: 16px;
  height: 36px;
  padding: 7px 14px;
  display: inline-block;
  box-sizing: border-box;
  line-height: 24px;
  .v-icon {
    color: #203f39;
    font-size: 16px;
  }

  button {
    margin-right: 15px;
    .v-icon {
      color: #ff3547;
    }
  }
}
</style>
